document.addEventListener("DOMContentLoaded", () => {
    const allTablesOnPage = document.querySelectorAll("table:not(.payment-products, .action-table)");

    if (allTablesOnPage.length > 0) {
        allTablesOnPage.forEach(t => {
            t.classList.add("table");
            const trs = document.querySelectorAll(`tr`);
            const tds = document.querySelectorAll(`td`);
            trs.forEach(row => {
                row.removeAttribute("style");
            });
            tds.forEach(cell => {
                cell.removeAttribute("style");
            });

            wrap(t, document.createElement("div"));
        });
    }
});

function wrap(el, wrapper) {
    wrapper.classList.add("table-responsive");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}

function addTableScopeAttributes() {
    const tables = document.querySelectorAll('table');

    tables.forEach(table => {
        const thElements = table.querySelectorAll('th');

        thElements.forEach(th => {
            if (th.hasAttribute('scope')) {
                return;
            }

            const parent = th.parentElement;
            const parentTagName = parent.tagName.toLowerCase();

            if (parentTagName === 'thead' || isInFirstRow(th, table)) {
                th.setAttribute('scope', 'col');
            } else if (isFirstCellInRow(th)) {
                th.setAttribute('scope', 'row');
            } else {
                const cellIndex = Array.from(parent.children).indexOf(th);
                const rowIndex = Array.from(table.querySelectorAll('tr')).indexOf(parent);

                if (cellIndex === 0) {
                    th.setAttribute('scope', 'row');
                } else if (rowIndex === 0) {
                    th.setAttribute('scope', 'col');
                } else {
                    th.setAttribute('scope', 'col');
                }
            }
        });
    });
}

function isInFirstRow(th, table) {
    const firstRow = table.querySelector('tr');
    return firstRow && firstRow.contains(th);
}

function isFirstCellInRow(th) {
    const row = th.parentElement;
    return row.children[0] === th;
}

document.addEventListener('DOMContentLoaded', addTableScopeAttributes);

function runAfterWYSIWYGLoad() {
    addTableScopeAttributes();
}

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'TABLE' || node.querySelectorAll('table').length > 0) {
                    setTimeout(addTableScopeAttributes, 100); // Small delay to ensure DOM is ready
                }
            }
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

window.fixTableScopes = addTableScopeAttributes;
